
let indexLang = {
    index: '首页',
    User: '用户管理',
    userlist: '所有用户',
    Account: '账户信息',
    Report: '账户报表',
    Setting: '系统设置',
    allAccount: '所有账户',
    introBroker: '我的介绍经纪商',
    retailAccount: '我的直属客户',
    personalReport: '个人统计',
    ibReport: '介绍经纪商',
    positionReport: '持仓报表',
    tradingHistory: '交易历史',
    discountSet: '佣金设置',
    groupSet: '用户组设置',
    operationLog: '操作日志',
    newAccount: '新开交易账户',
    dailyDeposit: '今日总入金数',
    dailyWithdraw: '今日总出金数',
    dailyVolume: '今日总交易量',
    monthReg: '客户数月增长',
    volumeSta: '交易量统计',
    customersActivity: '本月客户活跃度',
    tradeAccount: '交易账户',
    volume: '交易手数',
    activeAccount: '活跃用户',
    inactiveAccount: '不活跃用户',
    monthVolume: '月交易量',
    scale: '占比',
    pc: '个',
    fotter1: '',
    fotter2: ''
}

export default indexLang;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/indexLang.js